/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stale_Reload_BtnInputs */

const en_stale_reload_btn = /** @type {(inputs: Stale_Reload_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reload`)
};

const id_stale_reload_btn = /** @type {(inputs: Stale_Reload_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muat ulang`)
};

/**
* | output |
* | --- |
* | "Reload" |
*
* @param {Stale_Reload_BtnInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const stale_reload_btn = /** @type {((inputs?: Stale_Reload_BtnInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stale_Reload_BtnInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_stale_reload_btn(inputs)
	return en_stale_reload_btn(inputs)
});